import { createBrowserRouter, Navigate } from "react-router-dom"

import { ReviewPage } from "./components/ai-qc/review-page"
import ProtectedRoute from "./components/ProtectedRoute"
import RoleProtectedRoute from "./components/RoleProtectedRoute"
import AdminUsersPage from "./pages/AdminUsersPage"
import AIQCPage from "./pages/ai-qc"
import AIQCPendingPage from "./pages/ai-qc-pending"
import AIQCReviewedPage from "./pages/ai-qc-reviewed"
import AnalyticsPage from "./pages/analytics/AnalyticsPage"
import ContentOnlyUsersPage from "./pages/ContentOnlyUsersPage"
import CustdevPage from "./pages/CustdevPage"
import DoctorsPage from "./pages/DoctorsPage"
import GcpLogsPage from "./pages/GcpLogsPage"
import HomePage from "./pages/HomePage"
import LoginPage from "./pages/LoginPage"
import MarketingUsersPage from "./pages/MarketingUsersPage"
import OrderDetailPage from "./pages/OrderDetailPage"
import OrdersPage from "./pages/OrdersPage"
import PackageMappingsPage from "./pages/PackageMappingsPage"
import Page from "./pages/Page"
import PromptsPage from "./pages/PromptsPage"
import RegularUsersPage from "./pages/RegularUsersPage"
import SettingsPage from "./pages/SettingsPage"
import SupportUsersPage from "./pages/SupportUsersPage"
import SystemEventLogsPage from "./pages/SystemEventLogsPage"
import ToolsPage from "./pages/ToolsPage"
import UnhealthyCustomersPage from "./pages/UnhealthyCustomersPage"
import UserDetailPage from "./pages/UserDetailPage"

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Page>
          <HomePage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/analytics",
    element: (
      <ProtectedRoute>
        <Page>
          <AnalyticsPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/tools",
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={['admin', 'marketing', 'doctor', 'support']}>
          <Page>
            <ToolsPage />
          </Page>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/regular-users",
    element: (
      <ProtectedRoute>
        <Page>
          <RegularUsersPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/content-only-users",
    element: (
      <ProtectedRoute>
        <Page>
          <ContentOnlyUsersPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/doctors",
    element: (
      <ProtectedRoute>
        <Page>
          <DoctorsPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/support-users",
    element: (
      <ProtectedRoute>
        <Page>
          <SupportUsersPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin-users",
    element: (
      <ProtectedRoute>
        <Page>
          <AdminUsersPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/marketing-users",
    element: (
      <ProtectedRoute>
        <Page>
          <MarketingUsersPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/users/:id",
    element: (
      <ProtectedRoute>
        <Page>
          <UserDetailPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/unhealthy-customers",
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={['admin', 'support', 'marketing', 'doctor']}>
          <Page>
            <UnhealthyCustomersPage />
          </Page>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/orders",
    element: (
      <ProtectedRoute>
        <Page>
          <OrdersPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/orders/:id",
    element: (
      <ProtectedRoute>
        <Page>
          <OrderDetailPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/prompts",
    element: (
      <ProtectedRoute>
        <Page>
          <PromptsPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={['admin']}>
          <Page>
            <SettingsPage />
          </Page>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/custdev",
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={['admin', 'marketing']}>
          <Page><CustdevPage /></Page>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/package-mappings",
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={['admin', 'doctor']}>
          <Page>
            <PackageMappingsPage />
          </Page>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/ai-qc",
    element: (
      <ProtectedRoute>
        <Page>
          <AIQCPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/ai-qc/pending",
    element: (
      <ProtectedRoute>
        <Page>
          <AIQCPendingPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/ai-qc/reviewed",
    element: (
      <ProtectedRoute>
        <Page>
          <AIQCReviewedPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/ai-qc/review/:reviewId",
    element: (
      <ProtectedRoute>
        <Page>
          <ReviewPage />
        </Page>
      </ProtectedRoute>
    ),
  },
  {
    path: "/event-logs",
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={['admin', 'support']}>
          <Page>
            <SystemEventLogsPage />
          </Page>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/gcp-logs",
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={['admin', 'support']}>
          <Page>
            <GcpLogsPage />
          </Page>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
])
